import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Box, useMediaQuery } from '@mui/material';
import useStyles from './FFHeroBanner.styles';
import { useTextColor } from '../../styles/jss/utils';
import GenericImage from '../GenericImage/GenericImage';
import Content from '../Content/Content';
import { getContentPositionClass, getMinHeightClass, getValidFFHeroBannerButtonVariant, SiteContext, } from '../../utils/common';
import useCommonStyles from '../../styles/jss/common';
import { useContext } from 'react';
const FFHeroBanner = (props) => {
    var _a;
    const { contentPosition = 'LEFT', minHeight = 'MEDIUM', isFullWidthImage = false, headingTag = 'H3', image, darknessLevel, links, subheading, buttonVariant, backgroundColour, textColour, } = props;
    const validatedButtonVariant = getValidFFHeroBannerButtonVariant(buttonVariant);
    const { classes } = useStyles({ linksCount: (_a = links === null || links === void 0 ? void 0 : links.length) !== null && _a !== void 0 ? _a : 0, contentPosition, isFullWidthImage });
    const { classes: commonClasses } = useCommonStyles({});
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const { isFlyingFlowers } = useContext(SiteContext);
    const heading = typeof props.heading === 'string' && props.heading.trim()
        ? props.heading.split('/').map((line, index) => (_jsx("span", { className: clsx(classes.headingLine, contentPosition === 'CENTER' ? classes.centerHeading : ''), style: { backgroundColor: textColour }, children: line.trim() }, index)))
        : props.heading;
    // Always call hooks unconditionally with proper fallbacks
    const { textColor, backgroundColor: bgColor } = useTextColor(backgroundColour, undefined, isFlyingFlowers);
    const contentPositionClass = getContentPositionClass(contentPosition, {
        positionLeft: classes.positionLeft,
        positionCenter: classes.positionCenter,
        positionRight: classes.positionRight,
    });
    const minHeightClass = {
        minHeightSmall: commonClasses.minHeightSmall,
        minHeightMedium: commonClasses.minHeightMedium,
        minHeightLarge: commonClasses.minHeightLarge,
    };
    let imageClassNames = [];
    if (isMobile) {
        imageClassNames = [classes.mobileImage];
    }
    else if (!isFullWidthImage) {
        imageClassNames = [classes.squareImage];
    }
    else {
        imageClassNames = [classes.imageFit];
    }
    return (_jsxs(Box, { className: clsx(classes.container, contentPositionClass, getMinHeightClass(minHeight, minHeightClass), isMobile && classes.ffMobileheight), style: { backgroundColor: backgroundColour ? bgColor : undefined, color: textColour ? textColor : undefined }, children: [_jsx(GenericImage, Object.assign({}, props, { image: image, darknessLevel: darknessLevel, isPriority: true, renderSquaredImagesOptions: isFullWidthImage, showImageSpacer: true, fullWidthImage: true, minHeight: minHeight, addBackgroundColorForImage: true, backgroundColour: bgColor, classNames: imageClassNames })), _jsx(Content, Object.assign({}, props, { heading: heading, subheading: subheading, buttonVariant: validatedButtonVariant, subheadingClasses: [classes.subheading], containerClasses: [classes.content], linkContainerClasses: [classes.linkContainerClass], linkClassNames: [classes.linkClass], contentInnerClasses: contentPosition === 'CENTER' ? [classes.ffCenterContentInner] : [], messageClasses: [classes.message], headingClasses: [classes.heading], headingTag: headingTag, linkStyle: "BUTTON", links: links }))] }));
};
export default FFHeroBanner;
